import React from 'react';

interface SectionLabelProps {
  children: React.ReactNode;
  /** Conservé pour compatibilité d'API (non rendu dans le visuel actuel). */
  number?: string;
  variant?: 'light' | 'dark';
  align?: 'left' | 'center';
  className?: string;
}

/**
 * Petit "eyebrow" de section (libellé en capitales précédé d'un séparateur).
 * Reconstruit à l'identique depuis le bundle de production.
 */
const SectionLabel: React.FC<SectionLabelProps> = ({
  children,
  variant = 'light',
  align = 'left',
  className = '',
}) => {
  const isDark = variant === 'dark';
  const slashCls = isDark ? 'text-primary-400' : 'text-primary-600';
  const labelCls = isDark ? 'text-white/70' : 'text-primary-700';

  return (
    <div className={['flex items-center gap-3', align === 'center' ? 'justify-center' : '', className].join(' ')}>
      <span className={`text-sm font-bold leading-none ${slashCls}`} aria-hidden="true">
        /
      </span>
      <span className={`text-[11px] font-bold uppercase leading-none tracking-[0.2em] ${labelCls} sm:text-xs`}>
        {children}
      </span>
    </div>
  );
};

export default SectionLabel;
